export default "__VITE_ASSET__d6680aed__"